import { useEffect, useState } from "react";
import { Mail, Send } from "@/lib/icons";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export function CaseloadDigestCard() {
  const [enabled, setEnabled] = useState(null);
  const [preview, setPreview] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get("/clinician/digest").then((r) => setEnabled(r.data.enabled));
    api.get("/clinician/digest/preview").then((r) => setPreview(r.data));
  }, []);
  const toggle = async (v) => {
    setEnabled(v);
    await api.patch("/clinician/digest", { enabled: v });
    toast.success(v ? "You'll get a caseload digest every Monday at 8 am." : "Monday digest turned off.");
  };
  const sendNow = async () => {
    setBusy(true);
    try { const r = await api.post("/clinician/digest/send"); toast.success(`Digest emailed to ${r.data.sent_to}`); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); } finally { setBusy(false); }
  };
  if (enabled === null) return null;
  return (
    <section className="warm-card p-6" data-testid="caseload-digest-card">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div className="flex items-start gap-3">
          <Mail className="w-5 h-5 text-amber-700 mt-0.5" />
          <div>
            <h3 className="font-display text-lg font-bold text-stone-900">Monday caseload digest</h3>
            <p className="text-xs text-stone-500 mt-1 max-w-md">A short email every Monday at 8 am (your timezone): who checked in last week, who's gone quiet, new flags and open AI reviews. Counts and names only — no scales or notes.</p>
          </div>
        </div>
        <label className="inline-flex items-center gap-2 text-sm font-semibold text-stone-800 cursor-pointer">
          <input type="checkbox" checked={enabled} onChange={(e) => toggle(e.target.checked)} data-testid="caseload-digest-toggle" className="w-4 h-4 accent-amber-700" /> Email me on Mondays
        </label>
      </div>
      {preview && (
        <div className="mt-4 grid sm:grid-cols-4 gap-3" data-testid="caseload-digest-preview">
          {[["People", preview.clients.length], ["Active last week", preview.active], ["Quiet 5+ days", preview.quiet], ["AI items open", preview.ai_review_open]].map(([l, v]) => (
            <div key={l} className="rounded-2xl bg-stone-50 border border-stone-200 p-3"><div className="font-mono text-xl font-bold text-stone-900">{v}</div><div className="text-[10px] font-bold uppercase tracking-widest text-stone-500">{l}</div></div>
          ))}
        </div>
      )}
      <button onClick={sendNow} disabled={busy} data-testid="caseload-digest-send" className="mt-4 inline-flex items-center gap-1.5 text-xs font-semibold text-amber-800 hover:text-amber-900"><Send className="w-3.5 h-3.5" /> {busy ? "Sending…" : "Email me this week's digest now"}</button>
    </section>
  );
}
